<template>
  <div class="header header-border d-md-block">
    <div class="header-composite">
      <img
        class="header-bg"
        src="@/assets/Header/Header_bg.jpg"
        alt=""
        aria-hidden="true"
      />
      <img
        class="header-front"
        src="@/assets/Header/Header_front.png"
        alt="66. Kongress – Deutsche Gesellschaft für Gynäkologie und Geburtshilfe e.V."
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
};
</script>

<style lang="scss" scoped>
.header {
  border-bottom: 3px solid;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 10;
  background: #c78467;
  width: 100%;
  overflow: hidden;
}

.header-composite {
  position: relative;
  width: 100%;
  height: 100%;
}

.header-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 58% center;
}

.header-front {
  position: absolute;
  top: 50%;
  left: clamp(0.5rem, 3vw, 2.5rem);
  transform: translateY(-50%);
  height: clamp(48px, 72%, 150px);
  width: auto;
  max-width: min(78%, 560px);
  object-fit: contain;
  object-position: left center;
  z-index: 1;
}

@media (max-width: 767px) {
  .header-bg {
    object-position: 48% center;
  }

  .header-front {
    height: clamp(40px, 65%, 72px);
    max-width: min(88%, 320px);
    left: clamp(0.35rem, 2vw, 1rem);
  }
}

@media (min-width: 1200px) {
  .header-front {
    max-width: 620px;
  }
}
</style>
